import CategoriesAccordion from './CategoriesAccordion'


export default CategoriesAccordion
